import getParameterFromErrorResponse from '@/services/general/validation/parameterFromErrorResponse';

export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('SAME_SOCIETE') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.cannotBeMergedSameCompany',
        });
      }
      if (message.indexOf('TRANSFERT_SOCIETE_CANNOT_HAVE_SAME_INVOICE_CODING') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.cannotHaveSameInvoiceCoding',
        });
      }
      if (message.indexOf('AGENCES_NOT_SAME_SOCIETE') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.agencesNotSameSociete',
        });
      }
      if (message.indexOf('SOCIETE_MUST_HAVE_ONLY_ONE_REGLE_FACTURATION') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.societeMustHaveOnlyOneRegleFacturation',
          parametres: {
            societe: getParameterFromErrorResponse(message)[0],
          },
        });
      }
      if (message.indexOf('SOCIETE_STILL_HAS_AGENCIES') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.societeStillHasAgncies',
        });
      }
      if (message.indexOf('SOCIETE_MUST_HAVE_PRODUIT_ACHAT_AFFICHAGE') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.mustHaveProduitAchatAffichageId',
        });
      }
      if (message.indexOf('SOCIETE_MUST_HAVE_PRODUIT_ACHAT_GRATTAGE') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.mustHaveProduitAchatGrattageId',
        });
      }
      if (message.indexOf('SOCIETE_MUST_HAVE_PRODUIT_ACHAT_LAISSER_EN_PLACE') !== -1) {
        messages.push({
          message: 'detailSociete.fusionSociete.errors.mustHaveProduitAchatLaisserEnPlaceId',
        });
      }
    }
  });
}
